import { render } from "./NoPermissions.vue?vue&type=template&id=69e04738"
import script from "./NoPermissions.vue?vue&type=script&lang=js"
export * from "./NoPermissions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__